define("shared/types/tiktok", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.TiktokCommentStatus = _exports.QueryableTiktokCommentStatus = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  let TiktokCommentStatus = _exports.TiktokCommentStatus = /*#__PURE__*/function (TiktokCommentStatus) {
    TiktokCommentStatus["Public"] = "PUBLIC";
    TiktokCommentStatus["Hidden"] = "HIDDEN";
    return TiktokCommentStatus;
  }({});
  let QueryableTiktokCommentStatus = _exports.QueryableTiktokCommentStatus = /*#__PURE__*/function (QueryableTiktokCommentStatus) {
    QueryableTiktokCommentStatus["Public"] = "PUBLIC";
    QueryableTiktokCommentStatus["All"] = "ALL";
    return QueryableTiktokCommentStatus;
  }({});
});